import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrganizationService } from './organization.service';

@Injectable()
export class OrganizationInterceptor implements HttpInterceptor {
  private organizationService = inject(OrganizationService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers: Record<string, string> = {};
    const org = this.organizationService.selectedOrg();
    if (org) {
      headers = {
        'X-Organization-Id': org,
      };
    }
    const populateHeader = () => {
      const cloned = req.clone({
        setHeaders: {
          ...headers,
        },
      });
      return next.handle(cloned);
    };
    return populateHeader();
  }
}
